<script setup>
import TrustpilotSmall from '@js/Components/Trustpilot/TrustpilotSmall.vue'
import SectionDivider from '@js/Components/Marketing/SectionDivider/SectionDivider.vue'
import Container from '@js/Components/Container/Container.vue'
import { usePage } from '@inertiajs/vue3'
import RentbirdLogo from '@js/Components/Logos/RentbirdLogo/RentbirdLogo.vue'
import Button from '@js/Components/Forms/Button/Button.vue'
import { ON_COMPLETE_REDIRECT_TO_UPGRADE_PAGE, showCreateSearchProfileWizard } from '@js/App/SearchProfile'

const page = usePage()
</script>
<template>
  <div class="bg-purple-700">
    <SectionDivider :reversed="true" />
    <Container>
      <div class="text-white pb-12 lg:pb-20 pt-12 lg:pt-10">
        <div class="lg:hidden flex justify-center mb-4 lg:mb-8">
          <RentbirdLogo :href="false" size="md" />
        </div>
        <div class="lg:flex lg:w-full items-center justify-between">
          <div class="mb-4 lg:mb-0 xl:pl-20 lg:pr-4 lg:w-1/2 xl:w-[848px]">
            <h4 class="text-3xl lg:text-5xl text-center lg:text-left font-medium" v-html="$trans('CallToActionSectionCityPage.Title', { city: page.props.city_name})" />
          </div>
          <div class=" lg:pl-4 lg:w-1/2 lg:flex justify-end">
            <div class="lg:flex">
              <Button
                :big="true"
                :outline="true"
                tag="link"
                :href="$getLocalizedUrl('pricing')"
                :full-width-on-mobile="true"
                class="mb-4 lg:mr-4"
                icon-right="arrow-right"
              >
                {{ $trans('CallToActionSectionCityPage.ShowPricingButtonLabel') }}
              </Button>
              <Button
                :big="true"
                :full-width-on-mobile="true"
                icon-right="arrow-right"
                class="mb-4"
                @click="showCreateSearchProfileWizard(ON_COMPLETE_REDIRECT_TO_UPGRADE_PAGE)"
              >
                {{ $trans('CallToActionSectionCityPage.StartYourSearchButtonLabel') }}
              </Button>

              <TrustpilotSmall class="lg:hidden" />
            </div>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>
